// extracted by mini-css-extract-plugin
var _1 = "ActivityPostCard-module__animatedBackground--VLCny";
var _2 = "ActivityPostCard-module__footer--UVlR8";
var _3 = "ActivityPostCard-module__seriesContainer--Xb27R";
export { _1 as "animatedBackground", _2 as "footer", _3 as "seriesContainer" }
